const {PaginationMethod} = require('./constants')

/**
 * Returns whether the given pagination method is a dynamic batching method (infinite scroll or "load more" button)
 * @param method the method
 */
const isDynamicPaginationMethod = (method) =>
    method === PaginationMethod.SCROLL || method === PaginationMethod.LOAD_MORE


module.exports = {isDynamicPaginationMethod}